import { inject, Provider } from '@angular/core';

import { Cb2PreviewStateService } from '@core/services/cb2-preview/cb2-preview-state.service';

import {
  CHECKS_PAGE_BLOCK_DATA_SOURCE,
  ChecksPageBlockDataSource,
} from './checks-page-block-view-model';
import { ChecksPageBlockPreviewDataSource } from './checks-page-block-preview-data-source';
import { ChecksPageBlockStoreDataSource } from './checks-page-block-store-data-source';

export function provideChecksPageBlockDataSource(): Provider[] {
  return [
    ChecksPageBlockStoreDataSource,
    ChecksPageBlockPreviewDataSource,
    {
      provide: CHECKS_PAGE_BLOCK_DATA_SOURCE,
      useFactory: (): ChecksPageBlockDataSource => {
        const previewState = inject(Cb2PreviewStateService);
        return previewState.isActive()
          ? inject(ChecksPageBlockPreviewDataSource)
          : inject(ChecksPageBlockStoreDataSource);
      },
    },
  ];
}
